var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"add-new-btn"},[_vm._v("\n  Add New Class\n")])}
var staticRenderFns = []

export { render, staticRenderFns }